var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-ellipsis"},[_c('div',{class:_vm.background}),_vm._v(" "),_c('div',{class:_vm.background}),_vm._v(" "),_c('div',{class:_vm.background}),_vm._v(" "),_c('div',{class:_vm.background})])}
var staticRenderFns = []

export { render, staticRenderFns }